require('./hireCardECardStep3.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');

//@commons
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const PreContractualDocumentViewer = require('components/commons/preContractualDocumentViewer/preContractualDocumentViewer');

// @components
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');

// @constants
const {
    SECOND_STEP,
    THIRD_STEP
} = require('constants/index');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { E_CARD_GDPR_PID } = require('constants/gdprPlacementIds');
const {
    ECARD_HIRE,
    messages: { ECARD_HIRE_AND_GDPR }
} = require('constants/operationTypes');
const { E_CARD_PRODUCT_NAME, E_CARD_PRODUCT_TYPE } = require('constants/cardsPrecontractualMailInfo');

class hireCardECardStep3 extends React.Component {
    componentDidMount() {
        const {
            sendPrecontractualDocumentMail,
            setTermsAndCondsText,
        } = this.props;
        const precontractualMailProductInfo = {
            productAlias: E_CARD_PRODUCT_TYPE,
            productName: E_CARD_PRODUCT_NAME
        };
        sendPrecontractualDocumentMail(precontractualMailProductInfo);

        if (!__CONTACT_CENTER__) {
            setTermsAndCondsText('hireCardECard-hireCardECard_confirmationStepAgreementText');
        }
    }

    buildSummary() {
        const {
            immAccounts,
            immHireCardECard,
            immHireCardNameSelector,
        } = this.props;

        const selectedAccount = immHireCardECard.getIn(['steps', SECOND_STEP, 'accountId']);

        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const accountIban = getLastNChars(immAccount.get('iban'));

        return (
            <div className="hire-card-ecard-step-three__summary row">
                <div className="col-xs-6">
                    <div className="hire-card-ecard-step-three__summary-label">
                        <FormattedText value="hireCardECard-summarySelectedName" />
                    </div>
                    <div className="hire-card-ecard-step-three__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                </div>
                <div className="col-xs-6">
                    <div className="hire-card-ecard-step-three__summary-label">
                        <FormattedText value="hireCardECard-summarySelectedAccount" />
                    </div>
                    <div className="hire-card-ecard-step-three__summary-value">
                        <span>{immAccount.get('alias')}</span>
                        &nbsp;
                        <span>{accountIban}</span>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immHireCardECard, immPdfData } = this.props;
        const immStep = immHireCardECard.getIn(['steps', THIRD_STEP]);

        const params = {};

        const agreementLabel = <FormattedText value="hireCardECard-hireCardECard_confirmationStepAgreementText" />;
        const agreementChecked = immStep.get('agreementChecked');
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementErrorMsg = formatText('hireCardECard-step3CheckboxErrorMsg');
        const pdfError = immPdfData.get('errorContent');
        const summaryContent = this.buildSummary();
        const preContractDocumentInfo = getCardsPreContractPdfData()['prepaid_ecard'];
        let agreementCheckboxContent, GDPRSignaturePatternContent;

        if(!pdfError) {
            agreementCheckboxContent = (
                <div className="hire-card-ecard-step-three__checkbox-container">
                    <OKCheckbox
                        idName="hireCardECardAgreementCheckbox"
                        errorState={agreementErrorVisible}
                        errorMessage={agreementErrorMsg}
                        label={agreementLabel}
                        onChange={this.props.handleAgreementCheckboxChange}
                        value={agreementChecked}
                    />
                </div>
            )
        }

        if(agreementChecked) {
            GDPRSignaturePatternContent = (
                <GDPRSignaturePattern
                    operationType={ECARD_HIRE}
                    operationParams={params}
                    multiOTPMessageCode={ECARD_HIRE_AND_GDPR}
                />
            )
        }

        return (
            <article className="hire-card-ecard-step-three">
                <FormattedText
                    className="hire-card-ecard-step-three__title"
                    value="hireCardECard-step3Title"
                />
                <FormattedText
                    className="hire-card-ecard-step-three__subtitle"
                    value="hireCardECard-step3Subtitle"
                />
                {summaryContent}
                <OKConsents placementId={E_CARD_GDPR_PID} />
                <div className="hire-card-ecard-step-three__pdf-viewer-container">
                    <PreContractualDocumentViewer
                        preContractDocumentInfo={preContractDocumentInfo}
                        titleKey="preContractDocument_pdfTitlePrecontractual"
                    />
                </div>
                {agreementCheckboxContent}
                {GDPRSignaturePatternContent}
            </article>
        );
    }
}

hireCardECardStep3.propTypes = {
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immHireCardECard: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
};

module.exports = hireCardECardStep3;
